module.exports = __webpack_public_path__ + "static/media/insuranceArrow.a96b049c.svg";